import { render, staticRenderFns } from "./Multishop.vue?vue&type=template&id=7c252c98&"
import script from "./Multishop.vue?vue&type=script&lang=js&"
export * from "./Multishop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports